module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "268",
      "src": "images/2.jpg",
      "width": "350"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Being on your own is all about making decisions. Big decisions: What do I want to do with my life? And lots of little decisions: What kind of laundry detergent should I buy? What should I have for breakfast? To start, let’s go up to 30,000 feet and look at the big decisions. Then we’ll come back down and tackle the everyday nitty-gritty.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c426b77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 81
// module chunks = 0